class LocalizeByStoreError extends Error {
  constructor(message = 'Unknown store localization error') {
    super(message);
    this.name = "LocalizeByStoreError";
    this.message = message;
  }
}

export default LocalizeByStoreError;
